/* eslint-disable react/jsx-no-bind */
import React, { useState } from 'react';

import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { UI } from '../constants';

const FAQS = [
  {
    q: 'Do I need to trust you with my coins?',
    a: 'You deposit only after the rate is locked and the payout amount is fixed. Funds are held for the length of the transfer, not as a balance you have to leave with us.',
  },
  {
    q: 'What if the rate moves while I am sending?',
    a: 'Your quote holds for 60 seconds. If the network is slow and the rate moves past your lock, we requote and show you the new amount before anything settles.',
  },
  {
    q: 'Does the recipient need a SafiSwap account?',
    a: "No. Payouts land in the recipient's own mobile money account. They don't need an app or a wallet.",
  },
  {
    q: 'Which networks should I send USDT on?',
    a: 'USDT on TRC-20, BEP-20, or ERC-20. Pick the network that matches your wallet — the destination address is network-specific.',
  },
  {
    q: 'How do I fund my wallet from inside Somalia?',
    a: 'Log in with WhatsApp, choose Fund my wallet, and pay with local mobile money. Your balance tops up in crypto to the wallet you link or the address you enter.',
  },
  {
    q: 'What are your limits?',
    a: 'Start with any amount. Larger transfers may need additional verification before payout.',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(-1);

  function toggle(index) {
    if (openIndex === index) {
      setOpenIndex(-1);
      return;
    }
    setOpenIndex(index);
  }

  function getSymbol(index) {
    if (openIndex === index) return '×';
    return '+';
  }

  return (
    <Box id="faq" sx={{ bgcolor: UI.bgSoft, borderTop: `1px solid ${UI.border}` }}>
      <Container maxWidth="md" sx={{ py: { xs: 6, md: 9 } }}>
        <Typography
          sx={{
            fontSize: { xs: '1.7rem', md: '2.1rem' },
            fontWeight: 800,
            letterSpacing: '-0.02em',
            color: UI.text,
            mb: 3,
          }}
        >
          Questions
        </Typography>

        <Stack>
          {FAQS.map((faq, index) => (
            <Box key={faq.q} sx={{ borderTop: `1px solid ${UI.border}`, py: 2 }}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{ cursor: 'pointer' }}
                onClick={() => toggle(index)}
              >
                <Typography sx={{ fontSize: 16, fontWeight: 700, color: UI.text, pr: 2 }}>
                  {faq.q}
                </Typography>
                <Box sx={{ fontSize: 22, color: UI.textMuted, lineHeight: 1 }}>
                  {getSymbol(index)}
                </Box>
              </Stack>
              <Collapse in={openIndex === index}>
                <Typography sx={{ mt: 1.5, fontSize: 14.5, color: UI.textMuted, lineHeight: 1.75 }}>
                  {faq.a}
                </Typography>
              </Collapse>
            </Box>
          ))}
        </Stack>
      </Container>
    </Box>
  );
}
